import React, { Component, Fragment } from "react";
import NavBar from "../NavBar";
import { connect } from "react-redux";
import { createProject } from "../../../redux/store/actions/projectActions";
import { Redirect } from "react-router-dom";

class CrearProyecto extends Component {
  state = {
    title: "",
    content: ""
  };
  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };
  handleSubmit = e => {
    e.preventDefault();
    // console.log(this.state);
    this.props.createProject(this.state);
    this.props.history.push("/");
  };

  render() {
    const { auth } = this.props;
    if (!auth.uid) return <Redirect to="/signin" />;
    return (
      <Fragment>
        <NavBar />
        <div className="container pt">
          <h5 className="grey-text text-darken-3">Crea un nuevo proyecto</h5>
          <form onSubmit={this.handleSubmit} className="white">
            <div className="input-field">
              <label htmlFor="title">Nombre Proyecto</label>
              <input
                required
                type="text"
                id="title"
                onChange={this.handleChange}
              />
            </div>
            <div className="input-field">
              <label htmlFor="content">Contenido Proyecto</label>
              <textarea
                className="materialize-textarea"
                id="content"
                onChange={this.handleChange}
              />
            </div>

            <div className="input-field">
              <button className="btn blue accent-4">GUARDAR</button>
            </div>
          </form>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  // console.log(state);
  return {
    auth: state.firebase.auth
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createProject: project => dispatch(createProject(project))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CrearProyecto);
